import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';
//import { AuthContext } from '../helpers/AuthContext';

function CreatDecoration() {
  const [listeDeco, setListDeco] = useState([]);

  const navigate = useNavigate();
  const initialValues = {
    name: '',
    libelle: '',
    age: '',
    anneedeservice: '',
  };

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/login');
    }
  }, []);

  const enregistrer = (data) => {
    axios
      .post('/decoration', data, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((res) => console.log(res.data))
      .then((res) => console.log(res))
      .catch((error) => console.log(error));
    navigate('/decoration');
  };

  const validation = Yup.object().shape({
    name: Yup.string().required('Veuillez remplir le name'),
    libelle: Yup.string(),
    age: Yup.string(),
    anneedeservice: Yup.string(),
  });

  return (
    <React.Fragment>
      <div className="container mt-5 pt-3 ">
        <div>Brigade</div>
        <Formik enctype="multipart/form-data" onSubmit={enregistrer} initialValues={initialValues} validationSchema={validation}>
          <Form>
            <div className="row">
              <div className="col">
                <label htmlFor="name">Décoration : </label>
                <ErrorMessage className="text-danger" name="name" component="span" />
                <Field autocomplete="off" id="name" name="name" className="form-control" />
              </div>
              <div className="col">
                <label htmlFor="libelle">Libellé :</label>
                <ErrorMessage className="text-danger" name="libelle" component="span" />
                <Field autocomplete="off" id="libelle" name="libelle" className="form-control" />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label htmlFor="age">Age :</label>
                <ErrorMessage className="text-danger" name="age" component="span" />
                <Field autocomplete="off" id="age" name="age" className="form-control" />
              </div>
              <div className="col">
                <label htmlFor="anneedeservice">Annee de service : </label>
                <ErrorMessage className="text-danger" name="anneedeservice" component="span" />
                <Field autocomplete="off" id="anneedeservice" name="anneedeservice" className="form-control" />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <button type="submit" className="btn btn-success mt-4">
                  Enregistrer
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </React.Fragment>
  );
}

export default CreatDecoration;
